import { Component } from '@angular/core';

@Component({
  selector: 'app-p500',
  standalone: false,
  templateUrl: '500.component.html'
})
export class P500Component {

  constructor() { }

}
